import DimensionResults from './DimensionResults';

interface Dimension {
  name: string;
  abbreviation: string;
  user_score: number;
  expert_code: string;
  reliable: boolean;
}

interface Domain {
  name: string;
  dimensions: Dimension[];
}

interface DomainDimensionSectionProps {
  domains: Domain[];
  messages: any;
  i18n: any;
}

const DOMAIN_COLORS = ['bg-[#E9DFC7]', 'bg-[#C7D3DF]', 'bg-[#D6C7DF]'];

function getDomainColor(index: number): string {
  return DOMAIN_COLORS[index % DOMAIN_COLORS.length];
}

function DomainDimensionSection(props: DomainDimensionSectionProps) {
  const { domains, messages, i18n } = props;

  return (
    <>
      <div className="PrintMarginTop PrintBackgroundColor grid grid-cols-11 mx-1 text-sm md:text-base">
        <div className="pl-2 col-span-4 py-2 font-bold self-center">
          {i18n.ft(messages.columnTitle)}
        </div>
        <div className="col-span-2 py-2 font-bold text-center">
          {i18n.ft(messages.userScore)}
        </div>
        <div className="col-span-3 py-2 font-bold text-center">
          {i18n.ft(messages.expertCode)}
        </div>
        <div className="col-span-2 py-2 font-bold text-center">
          {i18n.ft(messages.reliable)}
        </div>
      </div>

      {domains.map(function (domain, idx) {
        return (
          <div key={idx}>
            <div
              className={`grid mx-1 text-sm md:text-xl rounded-lg ${getDomainColor(idx)}`}
            >
              <div className="py-2 font-bold pl-2 text-base sm:col-span-5 sm:my-2">
                {domain.name}
              </div>
            </div>
            <DimensionResults dimensions={domain.dimensions} />
          </div>
        );
      })}
    </>
  );
}

export default DomainDimensionSection;
